import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

class updateMemberDataApi extends Service {
  constructor(params: any) {
    super()

    this.name = 'UPDATE_MEMBER_DATA'
    this.config = {
      url: `/v1/member/profile`,
      method: 'PATCH',
      data: { ...params },
    }
  }
}

export const updateMemberData = (params: any) => getCallApiFunction(new updateMemberDataApi(params))
